import { Link } from "react-router-dom";
import { BRAND, WHATSAPP_URL, TEL_URL, MAPS_URL, SERVICES } from "../../lib/site-data";

export default function Footer() {
    const year = new Date().getFullYear();
    return (
        <footer className="relative mt-24 border-t border-white/5 bg-[#070707]" data-testid="site-footer">
            <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-16 py-16 grid gap-12 md:grid-cols-4">
                <div className="md:col-span-2 space-y-4">
                    <h3 className="font-display text-2xl text-white">{BRAND.name}</h3>
                    <p className="text-xs uppercase tracking-[0.25em] text-cyan-300/80">
                        {BRAND.owner}
                    </p>
                    <p className="text-sm text-zinc-400 max-w-md leading-relaxed">
                        Pico lazer dövme silme, cover-up öncesi açtırma ve Fraksiyonel CO2 lazer
                        ile iz görünümünü azaltma uygulamalarına yönelik kişisel ön değerlendirme.
                    </p>
                    <p className="text-xs text-zinc-500 max-w-md leading-relaxed">
                        Sonuçlar kişiden kişiye değişebilir. Net seans sayısı ve uygunluk, cilt yapısı ve
                        dövme/iz analizi sonrası belirlenir.
                    </p>
                </div>

                <div>
                    <p className="text-xs uppercase tracking-[0.25em] text-zinc-500 mb-4">
                        Hizmetler
                    </p>
                    <ul className="space-y-2">
                        {SERVICES.slice(0, 6).map((s) => (
                            <li key={s.slug}>
                                <Link
                                    to={`/${s.slug}`}
                                    className="text-sm text-zinc-300 hover:text-cyan-300"
                                >
                                    {s.title}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>

                <div>
                    <p className="text-xs uppercase tracking-[0.25em] text-zinc-500 mb-4">
                        İletişim
                    </p>
                    <ul className="space-y-2 text-sm">
                        <li>
                            <a href={TEL_URL} className="text-zinc-300 hover:text-cyan-300">
                                {BRAND.phone}
                            </a>
                        </li>
                        <li>
                            <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="text-zinc-300 hover:text-cyan-300">
                                WhatsApp Hattı
                            </a>
                        </li>
                        <li>
                            <a href={MAPS_URL} target="_blank" rel="noopener noreferrer" className="text-zinc-300 hover:text-cyan-300">
                                Yol Tarifi
                            </a>
                        </li>
                        <li className="text-zinc-400 text-xs leading-relaxed pt-2">
                            {BRAND.address}
                        </li>
                    </ul>
                </div>
            </div>
            <div className="border-t border-white/5">
                <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-16 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
                    <p className="text-xs text-zinc-500">
                        © {year} {BRAND.name}. Tüm hakları saklıdır.
                    </p>
                    <div className="flex items-center gap-5 text-xs">
                        <Link to="/kvkk-aydinlatma-metni" className="text-zinc-400 hover:text-cyan-300">
                            KVKK Aydınlatma Metni
                        </Link>
                        <Link to="/iletisim" className="text-zinc-400 hover:text-cyan-300">
                            İletişim
                        </Link>
                    </div>
                </div>
            </div>
        </footer>
    );
}
